import api, { ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { SearchDto } from '@/shared/types/search.dto';

export interface CreateProcessoSeletivoDto {
  id?: number;
  nome: string;
  dataInicioInscricoes: string;
  dataFimInscricoes: string;
  status?: 'rascunho' | 'pronto_para_iniciar' | 'aberto' | 'fechado' | 'finalizado';
  temTaxaInscricao?: boolean;
  valorTaxa?: number;
  dataVencimentoBoleto?: string;
  editalUrl?: string;
  cursoIds?: number[];
  vagas?: CreateVagaApiDto[];

  editadoPor?: {
    id: number;
    username: string;
  };
  editadoEm?: Date;
}

export interface CreateVagaDto {
  cursoId: number;
  municipios: string[];
}

// Tipo para envio ao backend (formato da API)
export interface CreateVagaApiDto {
  cursoId: number;
  comarcaId?: number;
  distritoId?: number;
  municipio?: string;
  quantidade: number;
}

export interface ReadVagaDto {
  id: number;
  comarcaId?: number;
  comarcaNome?: string;
  distritoId?: number;
  distritoNome?: string;
  cursoId: number;
  cursoNome: string;
  municipio?: string;
}

export interface ReadCursoDto {
  id: number;
  nome: string;
}

export interface ReadProcessoSeletivoDto {
  id: number;
  nome: string;
  dataInicioInscricoes: Date;
  dataFimInscricoes: Date;
  status: 'rascunho' | 'pronto_para_iniciar' | 'aberto' | 'fechado' | 'finalizado';
  temTaxaInscricao: boolean;
  valorTaxa: number;
  dataVencimentoBoleto: Date;
  editalUrl: string;
  cursos: ReadCursoDto[];
  vagas: ReadVagaDto[];
  editadoPor: {
    id: number;
    username: string;
  };
  editadoEm: Date;
  totalCandidatos?: number;
}

export type UpdateProcessoSeletivoDto = Partial<CreateProcessoSeletivoDto>;

export class ProcessoSeletivoService {
  async create(obj: CreateProcessoSeletivoDto): Promise<number> {
    try {
      return (await api.post(Endpoints.PROCESSO_SELETIVO, obj)).data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao cadastrar processo seletivo.');
    }
  }

  async findOne(id: number): Promise<ReadProcessoSeletivoDto> {
    try {
      const response = await api.get(Endpoints.PROCESSO_SELETIVO + '/' + id);
      return response.data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao buscar o processo seletivo.');
    }
  }

  async findOnePublic(id: number): Promise<ReadProcessoSeletivoDto> {
    try {
      const response = await api.get(Endpoints.PROCESSO_SELETIVO + '/public/' + id);
      return response.data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao buscar o processo seletivo.');
    }
  }

  async findOnePublicNome(id: number): Promise<{ id: number; nome: string }> {
    try {
      const response = await api.get(Endpoints.PROCESSO_SELETIVO + '/public/' + id + '/nome');
      return response.data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao buscar o processo seletivo.');
    }
  }

  async update(id: number, dto: UpdateProcessoSeletivoDto): Promise<void> {
    try {
      return (await api.put(Endpoints.PROCESSO_SELETIVO + '/' + id, dto)).data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao atualizar processo seletivo.');
    }
  }

  async remove(id: number): Promise<void> {
    try {
      await api.delete(Endpoints.PROCESSO_SELETIVO + '/' + id);
    } catch (error) {
      throw ValidateAxiosError(error, 'Falha ao remover processo seletivo.');
    }
  }

  async findAll(conditions: SearchDto): Promise<[ReadProcessoSeletivoDto[], number]> {
    try {
      const response = await api.get(Endpoints.PROCESSO_SELETIVO, {
        params: { skip: conditions.skip, take: conditions.take },
      });
      return response.data;
    } catch (error) {
      return ValidateAxiosError(error, 'Falha ao listar processos seletivos.');
    }
  }
}

